import {isRejectedWithValue, Middleware, MiddlewareAPI} from '@reduxjs/toolkit'
import {logOut} from '../../helpers/helpers'

interface EndpointArgs {
  endpointName: string
}

export const rtkQueryErrorLogger: Middleware =
  ({dispatch}: MiddlewareAPI) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      const {endpointName} = action.meta.arg as EndpointArgs
      const status = (action.payload as {status?: number}).status
      const unprotectedEndpoints = ['login', 'sendEmail', 'recoverPassword']
      const shouldLogOut = status === 401 && !unprotectedEndpoints.includes(endpointName)
      if (shouldLogOut) {
        logOut()
      }
    }
    return next(action)
  }
